import { PaymentsTranslations } from "./paymentTranslations.types";
import { getCgvLink } from "@/service/legalLinks/legalLinksService";

const cgvUrl = getCgvLink();

const paymentNlTranslations: PaymentsTranslations = {
    "paymentsPage": {
        "title": "Betaling",
        "paymentMyAccount": "Mijn account",
        "paymentChooseMethod": "Kies betaalmethode",
        "paymentByCreditCard": "Betaling met creditcard",
        "paymentByBancontact": "Betaling met Bancontact",
        "proceedToPay": "Doorgaan met betalen",
        "paymentByIdeal": "Betaal met iDeal",
        "paymentCreditCardPaymentCondition1Desc1": "Bij het Flex-tarief is de aanbetaling bij boeking",
        "paymentCreditCardPaymentCondition1Desc2": ", wat overeenkomt met",
        "paymentCreditCardPaymentCondition1Desc3": "van de totale reissom (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen).",
        "paymentCreditCardPaymentCondition1Desc4": "Het restbedrag",
        "paymentCreditCardPaymentCondition1Desc5": ", wordt automatisch afgeschreven op",
        "paymentCreditCardPaymentCondition1Notice1": "30% aanbetaling bij boeking, gratis wijzigen tot",
        "paymentCreditCardPaymentCondition1Notice12": "(excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen)",
        "paymentCreditCardPaymentCondition1Notice22": ". Aanpassing van opties uitgezonderd de accommodatie volgens",
        "paymentCreditCardPaymentCondition1Notice23": "ANVR-reisvoorwaarden",
        "paymentCreditCardPaymentCondition1Notice24": "&",
        "paymentCreditCardPaymentCondition1Notice25": "Aanvullende Travelski.nl voorwaarden",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit1": "Bij het Flex-tarief is de aanbetaling bij boeking",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit2": ", wat overeenkomt met",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit3": "van de totale reissom (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen).",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit4": "Het restbedrag",
        "paymentCreditCardPaymentCondition1DescPvBeforeDeposit5": ", wordt automatisch afgeschreven op",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit1": "30% aanbetaling bij boeking, gratis wijzigen tot",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit2": "(excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen). Wijzigingen van anders diensten, uitgezonderd de accommodatie, volgens",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit3": "ANVR-reisvoorwaarden",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit4": "&",
        "paymentCreditCardPaymentCondition1NoticePvBeforeDeposit5": "Aanvullende Travelski.nl voorwaarden",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit1": "Bij het Flex-tarief brengen wij bij boeking de totale reissom",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit2": "in rekening (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen).",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit3": "Kosteloos annuleren en wijzigen tot",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit4": "(excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen). Wijzigingen van anders diensten, uitgezonderd de accommodatie, en bij annulering Dutchweek, dan volgens",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit5": "ANVR-reisvoorwaarden",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit6": "&",
        "paymentCreditCardPaymentCondition1DescPvAfterDeposit7": "Aanvullende Travelski.nl voorwaarden",
        "paymentCreditCardPaymentCondition1NoticePvAfterDeposit1": "Volledige betaling bij boeking.",
        "paymentCreditCardPaymentCondition2Desc1": "Bij het FIX-tarief brengen wij bij boeking de totale reissom",
        "paymentCreditCardPaymentCondition2Desc2": "in rekening (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen). Dit bedrag is niet-restitueerbaar.",
        "paymentCreditCardPaymentCondition2Desc3": "Wijzigingen van anders diensten, uitgezonderd de accommodatie, en bij annulering Dutchweek, dan volgens",
        "paymentCreditCardPaymentCondition2Desc4": "ANVR-reisvoorwaarden",
        "paymentCreditCardPaymentCondition2Desc5": "&",
        "paymentCreditCardPaymentCondition2Desc6": "Aanvullende Travelski.nl voorwaarden",
        "paymentCreditCardPaymentCondition2Notice1": "Volledige betaling bij boeking. Niet-restitueerbaar.",
        "paymentErrorPopupTitle": "Betaling geweigerd",
        "paymentErrorPopupText": "Excuses, je betaling is geweigerd. Probeer het opnieuw of neem contact met ons op via",
        "paymentErrorPopupButton": "OK",
        "paymentStatusCheckPayment": "Betaling controleren",
        "paymentStatusConfirmPayment": "Betaling bevestigen",
        "paymentStatusCheckAvailability": "Controleer de beschikbaarheid van de accommodatie",
        "loadingPrice": "Prijs laden...",
        "accommodationUnavailable": "Accommodatie niet beschikbaar",
        // Train-only
        "trainOnlyConditionsDescription": `Annulering en wijziging volgens de <a href="${cgvUrl}" target="_blank" rel="noopener">algemene verkoopvoorwaarden</a>.`,
        "paymentConditionsDescriptionFlex": `Gratis wijzigen tot <b>slot_date</b> (excl. servicekosten: boekingskosten, SGR, Calamiteitenfonds, evt. verzekeringen). 
        Volledige betaling bij boeking, niet-annuleerbaar en niet-restitueerbaar vanaf <b>slot_date</b>. Wijzigingen van anders diensten, uitgezonderd de accommodatie, en bij annulering Dutchweek, dan volgens <a href="${cgvUrl}" target="_blank">ANVR-reisvoorwaarden.</a>`,
        "paymentConditionsDescriptionFixe": "Volledige betaling bij boeking. Niet-restitueerbaar.",
        "fixeProduct": "Fix",
        "flexProduct": "Flex",
        "paymentAmountDescriptionFlex": "Het resterende bedrag wordt automatisch afgeschreven op de hierboven vermelde data.",
        "paymentAmountDescriptionFixe": "Bij het FIX-tarief brengen wij bij boeking de totale reissom <b>deposit_amount</b> in rekening (incl. servicekosten: boekingskosten, SGR, Cal.Fonds, evt. verzekeringen). Dit bedrag is niet-restitueerbaar.",
        "paymentNotReady": "Betaling niet klaar",
        "checkParticipants": "Controleer deelnemersinformatie",
        "checkFlight": "Controleer vluchtbeschikbaarheid",
        "checkAccommodationStock": "Controleer accommodatievoorraad",
        "accommodationNoLongerAvailable": "Deze accommodatie is niet meer beschikbaar",
        "accommodationUnavailableModalTitle": "Deze accommodatie is niet meer beschikbaar.",
        "accommodationUnavailableModalText1": "Helaas is de door jou geselecteerde accommodatie niet meer beschikbaar.",
        "accommodationUnavailableModalText2": "We nodigen je uit om een alternatief verblijf uit ons aanbod te kiezen.",
        "accommodationUnavailableModalClose": "Sluiten",
        "accommodationUnavailableModalCta": "Bekijk andere accommodaties",
        "fillParticipantsDetailsMessage": "Vul de deelnemersgegevens in om door te gaan met betalen",
        "paymentModeTitle": "Kies je betaaloptie",
        "payNowPartial": "Betaal aanbetaling nu",
        "payNowFull": "Betaal het volledige bedrag nu",
        "payLater": "scheduled_amount op slot_date",
        "payInitialDepositNow": "Betaal nu de eerste aanbetaling {amount} p.p.",
        "scheduledSecondDepositLine": "2e aanbetaling van {amount} verschuldigd op {date}",
        "scheduledBalanceLine": "Saldo van {amount} verschuldigd op {date}",
        "scheduledFurtherPaymentLine": "Verdere betaling van {amount} verschuldigd op {date}",
        "remainingToPayAdyen": "Nog te betalen: <b>{amount}</b>"
    },
    "systempayError": {
        "0": "",
        "2": "",
        "3": "",
        "4": "",
        "5": "Uw betaling is niet goedgekeurd door uw bank.\n\nWij raden u aan contact op te nemen met uw bank voor meer informatie of een andere betaalmethode te proberen.\n\nDank u voor uw begrip.",
        "7": "",
        "8": "",
        "12": "",
        "13": "",
        "14": "",
        "15": "",
        "17": "",
        "19": "",
        "20": "",
        "24": "",
        "25": "",
        "26": "",
        "27": "",
        "28": "",
        "29": "",
        "30": "",
        "31": "",
        "33": "",
        "34": "",
        "38": "",
        "41": "",
        "43": "",
        "46": "",
        "51": "Uw betaling kon niet worden uitgevoerd vanwege een onvoldoende saldo of omdat uw kredietlimiet is overschreden.\n\nWij nodigen u uit om uw account te controleren of contact op te nemen met uw bank voor meer informatie. U kunt ook een andere betaalmethode kiezen.\n\nDank u voor uw begrip.",
        "54": "",
        "55": "",
        "56": "",
        "57": "Uw betaling kon niet worden verwerkt, omdat dit type transactie niet is toegestaan voor uw kaart.\n\nWij raden u aan contact op te nemen met uw bank voor meer informatie of een andere betaalmethode te gebruiken.\n\nDank u voor uw begrip.",
        "58": "",
        "59": "Het spijt ons, maar uw betaling kon niet worden gevalideerd vanwege een vermoeden van fraude. Om veiligheidsredenen hebben we deze transactie opgeschort.\n\nControleer alstublieft uw betalingsgegevens en probeer het opnieuw. Als het probleem aanhoudt, raden wij u aan contact op te nemen met onze klantenservice of een andere betaalmethode te gebruiken.\n\nDank u voor uw begrip.",
        "60": "",
        "61": "",
        "63": "",
        "65": "",
        "68": "",
        "75": "",
        "76": "",
        "78": "",
        "80": "",
        "81": "",
        "82": "",
        "83": "",
        "84": "",
        "86": "",
        "88": "",
        "90": "",
        "91": "",
        "94": "",
        "96": "",
        "97": "",
        "98": "",
        "99": ""
    },
    "participant": {
        title: "Deelnemersgegevens",
        addParticipant: "Deelnemer toevoegen",
        participant: "Deelnemer",
        removeParticipantModalTitle: "Deelnemer verwijderen",
        removeParticipantModalBody: "Wil je deelnemer",
        removeParticipantModalDismiss: "Annuleren",
        removeParticipantModalValidate: "Verwijderen",
        yearsOld: "jaren oud",
        checkNameTitle: "Controleer de namen",
        checkNameContent: "Elke naam moet identiek zijn aan de gegevens in je identiteitsbewijs.",
        checkNameContentLikeInPassport: "Elk naam moet precies zoals in het paspoort verschijnen.",
        placeholderDataWarning: "Vergeet niet de voornamen, achternamen en geboortedata van alle deelnemers in te vullen.",
        male: "Man",
        female: "Vrouw",
        firstName: "Voornaam",
        lastName: "Achternaam",
        dayShort: "DD",
        monthShort: "MM",
        yearShort: "JJJJ",
        dateOfBirth: "geboortedatum",
        submit: "Bevestigen",
        delete: "Verwijderen deelnemer",
        childTrainFreeMessage: "Uw kind onder de 3 jaar reist gratis bij u in de gedeelde coupé."
    },
    "quote": {
        "saveYourQuote": "Uw zoekopdracht opslaan",
        "devisDesc1": "Door uw zoekopdracht op te slaan, kunt u deze <b>terugvinden in uw persoonlijke ruimte onder 'Mijn klantaccount'</b> om op elk gewenst moment tot betaling over te gaan. <br> <br> <b>Opmerking:</b> Controleer de beschikbaarheid van uw verblijf op het moment van reserveren.",
        "devisDesc4": ":",
        "devisDesc5": "Controleer de beschikbaarheid van uw verblijf op het moment van reserveren.",
        "save": "Opslaan",
        "makeQuote": "Uw verblijfszoekopdracht"

    }
}

export default paymentNlTranslations;